import React from "react"

import TopicLayout from "../shared/TopicLayout"
import {Arrow, Box, Diagram} from "../shared/Diagram"

export default function ConsensusAndLeaderElection() {
    return (
        <TopicLayout
            title="Consensus & leader election"
            intro="How a group of replicas agrees on a single value or picks one coordinator, even when nodes are slow or crash. This is the mechanism underneath protocols like Raft and Paxos, and anything that needs one active writer."
            diagram={
                <Diagram viewBox="0 0 560 220">
                    <text x={280} y={14} textAnchor="middle" fontSize={12} opacity={0.8}>5-node cluster: one leader, four followers</text>
                    <Box x={235} y={50} width={90} height={40} label="Leader" sublabel="elected: 3/5 votes" accent/>
                    <Box x={20} y={150} width={90} height={40} label="Follower"/>
                    <Box x={160} y={150} width={90} height={40} label="Follower"/>
                    <Box x={300} y={150} width={90} height={40} label="Follower"/>
                    <Box x={440} y={150} width={90} height={40} label="Follower"/>
                    <Arrow x1={250} y1={90} x2={65} y2={150}/>
                    <Arrow x1={265} y1={90} x2={205} y2={150} label="replicate log entries"/>
                    <Arrow x1={295} y1={90} x2={345} y2={150}/>
                    <Arrow x1={310} y1={90} x2={485} y2={150}/>
                    <text x={280} y={200} textAnchor="middle" fontSize={11} opacity={0.7}>A write commits once a majority of nodes acknowledge it</text>
                </Diagram>
            }
            useWhen={[
                'Multiple replicas must agree on the same ordered sequence of operations, such as a replicated log, or on who is currently allowed to act as the single writer.',
                'A cluster needs to keep working correctly through node crashes and network delays, not just the happy path.'
            ]}
            tradeOff="Consensus protocols trade raw throughput for correctness guarantees: every write typically needs acknowledgement from a majority of nodes before it is considered committed, which costs at least one network round trip to the slowest node in that majority. A cluster of size 2f+1 tolerates f node failures, so bigger clusters survive more failures but need larger majorities and more replication traffic per write. Running this yourself is notoriously easy to get subtly wrong — reach for a proven implementation (etcd, ZooKeeper, a Raft library) rather than hand-rolling leader election."
            ruleOfThumb="Use an existing, battle-tested consensus system for coordination and leader election rather than building one; size the cluster from the failure tolerance you actually need, and remember that consensus buys correctness, not latency."
        />
    )
}
